import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'color-text',
  templateUrl: './color-text.component.html',
  styleUrls: ['./color-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColorTextComponent implements OnInit {

  @Input()
  text;
  @Input()
  config;

  color = '#363636';

  constructor() { }

  ngOnInit() {
    for (let i = 0; i < this.config.segments.length; i++) {
      if (this.text === this.config.segments[i].text) {
        this.color = this.config.segments[i].color;
        this.text = this.config.segments[i].alias || this.text;
        break;
      }
    }
  }
}
